import { Injectable } from '@angular/core';
import * as xml2js from 'xml2js';

@Injectable({
  providedIn: 'root'
})
export class XmlToJsonParserService {
  parser = new xml2js.Parser({
    strict: false,
    trim: true,
    tagNameProcessors: [this.nameAsItIs],
    attrNameProcessors: [this.nameAsItIs],
    valueProcessors: [this.nameAsItIs],
    attrValueProcessors: [this.nameAsItIs]
  });
  builder = new xml2js.Builder();

  constructor() {}

  parseXMLToJSON(xmlString: string): any {
    let jsonObject;
    this.parser.parseString(xmlString, (err, result) => {
      jsonObject = result;
    });

    return jsonObject;
  }

  parseJsonToXml(xmlString: any) {
    var builder = new xml2js.Builder();
    return builder.buildObject(xmlString);
  }

  buildXMLFromJSON(jsonObject: any): string {
    return this.builder.buildObject(jsonObject);
  }

  nameAsItIs(name: string): string {
    return name;
  }

  nameToUpperCase(name: string): string {
    return name.toUpperCase();
  }
}
